import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import InfoMessage from '@kurtosys/ksys-app-components/dist/components/message/InfoMessage';

export default InjectedStyledComponent(InfoMessage, 'app', ['infoMessage']);